export enum BusinessGroup {
	etus = 'ETUS',
	etca = 'ETCA',
	ea = 'EAUS',
	cst = 'CST',
	cous = 'COUS',
	gst = 'GST',
	unknown = 'UNKNOWN',
}
